import {createAction} from '@reduxjs/toolkit'
import {EnvironmentState} from '../reducers/environment'

export const setEnvironment = createAction<EnvironmentState>('SET_ENVIRONMENT')

export type SetEnvironment = typeof setEnvironment
